import RateDetailItem, { RateDetailItemProps } from './RateDetailItem';

export type { RateDetailItemProps };
export default RateDetailItem;
